export default __webpack_public_path__ + "static/media/W_D_True.a954e81c.jpg";